/**
 * This component was generated from a script. DO NOT MODIFY THIS FILE or your
 * changes will be overridden the next time icon components are generated. to
 * make persistent changes, modify the icon-template.hbs file and re run the
 * "npm run generate-icons" script
 */

import React from 'react';
import { Icon, IconProps } from '../Icon.component';

export const CaretDownAltIconSmall: React.FC<React.PropsWithChildren<IconProps>> = (props) => (
  <Icon size={16} {...props} viewBox='0 0 16 16'>
    <path
      fillRule='evenodd'
      d='M8.82206 10.9416C8.42438 11.5156 7.57576 11.5156 7.17807 10.9416L3.89129 6.19751C3.43181 5.5343 3.90647 4.62801 4.71329 4.62801L11.2868 4.62801C12.0937 4.62801 12.5683 5.53431 12.1088 6.19751L8.82206 10.9416Z'
    />
  </Icon>
);
